import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";

import Projects from "../../api/projects";

import pImg1 from "../../images/portfolio-single/1.jpg";
import pImg2 from "../../images/portfolio-single/2.jpg";
import pImg3 from "../../images/portfolio-single/3.jpg";

interface ProjectItem {
  id: string;
  slug: string;
  title?: string;
  pimg1?: string;
  date?: string;
  location?: string;
}

const ProjectSinglePage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  const projectDetails: ProjectItem | undefined = Projects.find(
    (item: ProjectItem) => item.slug === slug
  );

  // 🧩 Handle invalid or missing project slug
  if (!projectDetails) {
    return (
      <Fragment>
        <Navbar hclass="wpo-header-style-1" />
        <PageTitle pageTitle="Project Not Found" pagesub="Error" />
        <section className="wpo-portfolio-single-section section-padding text-center">
          <div className="container">
            <h2>Sorry! Project not found.</h2>
            <p>The project you are looking for does not exist or has been removed.</p>
          </div>
        </section>
        <Footer footerClass="wpo-site-footer-s1" />
        <Scrollbar />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Navbar hclass="wpo-header-style-1" />
      <PageTitle pageTitle={projectDetails.title || "Project Details"} pagesub="Service" />

      <section className="wpo-portfolio-single-section section-padding">
        <div className="container">
          <div className="portfolio-single-wrap">
            <div className="row">
              {/* Left Column - Images */}
              <div className="col-lg-7 col-12">
                <div className="portfolio-single-img-wrap">
                  <div className="portfolio-single-img">
                    <img src={projectDetails.pimg1} alt={projectDetails.title || "Project"} />
                  </div>
                  <div className="portfolio-single-img">
                    <img src={pImg1} alt="Portfolio Detail" />
                  </div>
                  <div className="portfolio-single-img">
                    <img src={pImg2} alt="Portfolio Detail" />
                  </div>
                  <div className="portfolio-single-img">
                    <img src={pImg3} alt="Portfolio Detail" />
                  </div>
                </div>
              </div>

              {/* Right Column - Details */}
              <div className="col-lg-5 col-12">
                <div className="portfolio-single-sitebar">
                  <div className="portfolio-single-text">
                    <h2>Marriage For Life</h2>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Metus dis posuere amet tincidunt
                      commodo, velit. Ipsum, hac nibh fermentum nisi, platea condimentum cursus velit dui. Massa
                      volutpat odio facilisis purus sit elementum. Non, sed velit dictum quam.
                    </p>

                    <div className="wpo-portfolio-single-content-des">
                      <ul>
                        <li>
                          Location : <span>{projectDetails.location || "Unknown"}</span>
                        </li>
                        <li>
                          Client : <span>{projectDetails.title}</span>
                        </li>
                        <li>
                          Photographer : <span>Harry Johnson</span>
                        </li>
                        <li>
                          Project Type : <span>Photography</span>
                        </li>
                        <li>
                          Duration : <span>6 Month</span>
                        </li>
                        <li>
                          Tag : <span>Wedding, Planner, Bride, GItem</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer footerClass="wpo-site-footer-s1" />
      <Scrollbar />
    </Fragment>
  );
};

export default ProjectSinglePage;
